/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EventId/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function EventId({
  children,
  viewPath = "/DesignSystem/SentryErrorBoundary/SentryErrorBoundaryFallback/EventId"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let errorIdValueData = fromData.useDataValue({ viewPath,
context: 'error',
path: 'id',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 text="Event ID"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="error.id"
 text={errorIdValueData}
/>
{children}
</React.Fragment>)
}